export default __webpack_public_path__ + "static/media/IMG-20240729-WA0020.f0efcd03.jpg";